<template>
    <div>
        <progress-header />

        <div class="container mt-4">
            <h1 class="text-blue-600 font-weight-bold">{{ $t('coaches.first_header') }}</h1>
            <h2 class="text-blue-600">{{ $t('coaches.second_header') }}</h2>

            <div class="card booking-form-card shadow-sm mt-2 mx-auto">
                <div class="card-header py-3">
                    <span class="icon position-pin-icon"></span>

                    {{ $t('coaches.summary.basic_information') }}
                </div>

                <coach-search-form offer-type="bt" @search="search" />
            </div>
        </div>
    </div>
</template>

<script>
    import CoachSearchForm from './components/CoachSearchForm';
    import ProgressHeader from './components/ProgressHeader';
    import {trackGA} from '@utilities/tracking';

    export default {
        components: {ProgressHeader, CoachSearchForm},
        data() {
            return {
                currentComponent: 'transfer-type',
            };
        },

        created() {
            trackGA('view_item', {
                'items': [
                    {
                        id: window.location.pathname,
                        name: 'Wynajem Autokarów',
                        quantity: 1,
                    },
                ],
            });

            this.storeCode();
        },

        methods: {
            storeCode() {
                let code = null;
                if (this.$route.params.code) {
                    code = this.$route.params.code;
                }

                this.$store.dispatch('coachesOrder/setCode', code);
            },

            search(data) {
                this.$store.dispatch('coachesOrder/setSearchParameters', data)
                    .then(() => {
                        this.$store.dispatch('coachesOrder/setIsRouteInfoComplete', true)
                            .then(() => {
                                this.$router.push({ name: 'coaches.transfer-type'});
                            });
                    });
            },
        },
    };
</script>

<style scoped>
    .container {
        max-width: 800px;
    }

    .card-header {
        padding-left: 32px;
    }

    h1 {
        font-size: 1.4rem;
    }

    h2 {
        font-size: 1.2rem;
    }
</style>

